import React from 'react';
import DefaultTooltipPopover from './DefaultTooltipPopover';
import TooltipContainer, { TooltipContainerProps } from './TooltipContainer';

/**
 * Default implementation of an accessible tooltip component.
 *
 * For more advanced use cases, see `TooltipContainer`, `TooltipPopover`,
 * and `useTooltip`.
 */
export interface TooltipProps extends TooltipContainerProps {
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  arrow,
  children,
  className,
  contents,
  defaultOpen,
  delay,
  isDisabled,
  isOpen,
  offset = 8 + (arrow ? 4 : 0),
  onOpenChange,
  placement = 'top',
  strategy = 'absolute',
  trigger,
}) => {
  return (
    <TooltipContainer
      {...{
        arrow,
        defaultOpen,
        delay,
        isDisabled,
        isOpen,
        offset,
        onOpenChange,
        placement,
        strategy,
        trigger,
      }}
      contents={({ state }) =>
        state.isOpen && (
          <DefaultTooltipPopover className={className}>
            {contents}
          </DefaultTooltipPopover>
        )
      }
    >
      {children}
    </TooltipContainer>
  );
};

export default Tooltip;
